import { useEffect } from 'react'
import './Pricing.css'

function Pricing() {
  useEffect(() => {
    // Smooth scroll para anchors cuando la página carga con hash
    if (window.location.hash) {
      setTimeout(() => {
        const target = document.querySelector(window.location.hash)
        if (target) {
          const offsetTop = target.offsetTop - 80 // Ajuste para navbar fija
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          })
        }
      }, 100)
    }

    // Smooth scroll para links internos
    const handleAnchorClick = (e) => {
      const href = e.target.getAttribute('href')
      if (href && href.startsWith('#')) {
        e.preventDefault()
        const target = document.querySelector(href)
        if (target) {
          const offsetTop = target.offsetTop - 80
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          })
        }
      }
    }

    const anchorLinks = document.querySelectorAll('a[href^="#"]')
    anchorLinks.forEach(link => {
      link.addEventListener('click', handleAnchorClick)
    })

    return () => {
      anchorLinks.forEach(link => {
        link.removeEventListener('click', handleAnchorClick)
      })
    }
  }, [])

  return (
    <>
      {/* ===== PRICING SECTION ===== */}
      <section id="pricing" className="pricing-section">
        <div className="pricing-inner">
          <h2 className="pricing-title">PRICING</h2>
          <div className="pricing-wavy-line"></div>

          <div className="pricing-content">
            <div className="pricing-illustration">
              <img src="/img/mozo.png" alt="Drinks tray illustration" />
            </div>
            <div className="pricing-copy">
              <h3 className="pricing-subtitle">Find your fit</h3>
              <p className="pricing-text">
                <span><strong>For now, all tools are free.</strong> Start planning your wedding today with our complete suite of free tools.</span>
                <span>No credit card required, no hidden fees. Just sign up and start planning.</span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== PRICING PRICES TABLE ===== */}
      <section className="pricing-prices-section">
        <p className="pricing-smooth-text">Wedding planning made smooth (without the scary price tag).</p>
        <div className="pricing-description">
          <p>Here's what you get with each plan—clear, simple, and built to keep your wedding planning moving without the chaos.</p>
          <p><strong>All tools are currently free and fully functional.</strong> Every package comes with the essentials. The difference? How much support and structure you want along the way.</p>
        </div>
        <div className="pricing-arrow">
          <img src="/img/flecha.png" alt="Scroll down" className="arrow-img" />
        </div>
        <div className="pricing-prices-container">
          <a href="#chill-mode" className="price-box-link">
            <div className="price-box">
              <h3 className="price-plan-name">CHILL MODE</h3>
              <p className="price-description">(It's free... and all tools are live now.)</p>
            </div>
          </a>
          <a href="#level-up" className="price-box-link">
            <div className="price-box">
              <h3 className="price-plan-name">LEVEL UP</h3>
              <p className="price-description">More control, less chaos.</p>
            </div>
          </a>
          <a href="#wedding-ceo" className="price-box-link">
            <div className="price-box">
              <h3 className="price-plan-name">WEDDING CEO</h3>
              <p className="price-description">Full control. Full calm.</p>
            </div>
          </a>
        </div>
      </section>

      {/* ===== CHILL MODE SECTION ===== */}
      <section id="chill-mode" className="plan-section">
        <h2 className="plan-title">"CHILL MODE"</h2>
        <div className="plan-wavy-line"></div>

        <div className="plan-content">
          {/* Feature 01 */}
          <div className="about-feature">
            <div className="feature-content">
              <h3 className="feature-subtitle">Dynamic Wedding Checklist <span className="live-badge">LIVE</span></h3>
              <div className="feature-text">
                <p>A pre-assigned, fully editable checklist that automatically adjusts to your wedding date.</p>
                <p className="plan-feature-tagline">
                  <span>Calculating, no panic math.</span>
                  <span>Peace of mind, built-in.</span>
                </p>
              </div>
              <div className="feature-wavy-line"></div>
            </div>
            <div className="feature-illustration"></div>
          </div>

          {/* Feature 02 */}
          <div className="about-feature">
            <div className="feature-content">
              <h3 className="feature-subtitle">RSVP's <span className="live-badge">LIVE</span></h3>
              <div className="feature-text">
                <p>Tracking who's in (and who's out) has never been easier. Guests RSVP Yes/No, add their plus-one, and you can customise your invite with any photo. Keep everything in one place and smoothly assign tables in the Guest Manager.</p>
                <p className="plan-feature-tagline">
                  <span>No messy spreadsheets. No endless group chats. Just RSVPs that actually make sense.</span>
                </p>
              </div>
              <div className="feature-wavy-line"></div>
            </div>
            <div className="feature-illustration"></div>
          </div>

          {/* Feature 03 */}
          <div className="about-feature">
            <div className="feature-content">
              <h3 className="feature-subtitle">Guest Manager <span className="live-badge">LIVE</span></h3>
              <div className="feature-text">
                <p>Keep every guest in one simple list — with tags like family, friends, work, so you instantly know who's who. A mini dashboard shows X confirmed / Y total invited.</p>
                <p className="plan-feature-tagline">Clear, organised, and way easier than juggling five lists — plus, you can manually allocate guests to tables.</p>
              </div>
              <div className="feature-wavy-line"></div>
            </div>
            <div className="feature-illustration"></div>
          </div>

          {/* Feature 04 */}
          <div className="about-feature">
            <div className="feature-content">
              <h3 className="feature-subtitle">Budget Tracker <span className="live-badge">LIVE</span></h3>
              <div className="feature-text">
                <p>Set your wedding budget when you sign up. Then, just add expenses as you go — the tracker shows you exactly what % of your budget you've used.</p>
                <p className="plan-feature-tagline">
                  <span>No financial panic. Just clarity.</span>
                </p>
              </div>
              <div className="feature-wavy-line"></div>
            </div>
            <div className="feature-illustration">
              <img src="/img/dinero.png" alt="Budget tracker" className="feature-img" />
            </div>
          </div>
        </div>
      </section>

      {/* ===== BACK TO PRICING BUTTON ===== */}
      <section style={{ textAlign: 'center', padding: '10px 2rem 60px' }}>
        <a href="#pricing" className="btn-back-pricing">Back to Pricing</a>
      </section>

      {/* ===== LEVEL UP SECTION ===== */}
      <section id="level-up" className="plan-section">
        <h2 className="plan-title">LEVEL UP</h2>
        <div className="plan-wavy-line"></div>

        <div className="plan-content">
          {/* Feature 01 */}
          <div className="about-feature">
            <div className="feature-content">
              <h3 className="feature-subtitle">RSVP's <span className="live-badge">LIVE</span></h3>
              <div className="feature-text">
                <p>Get even more control. Customise your RSVP form to collect dietary requirements, tag guests by group — family, friends, or "needs accommodation" — and send tailored questions to each list.</p>
                <p>With the lifesaver link, guest details are collected faster, smoother, and with way less stress. Smart RSVP management, done right.</p>
              </div>
              <div className="feature-wavy-line"></div>
            </div>
            <div className="feature-illustration">
              <img src="/img/torta.png" alt="RSVP's" className="feature-img" />
            </div>
          </div>

          {/* Feature 02 */}
          <div className="about-feature">
            <div className="feature-content">
              <h3 className="feature-subtitle">Suppliers Manager <span className="live-badge">LIVE</span></h3>
              <div className="feature-text">
                <p>Keep all your wedding pros in one place — photographer, florist, catering, you name it. Add their contact details, rates, and key dates so you never lose track (or that one random email thread).</p>
                <p className="plan-feature-tagline">One dashboard, zero supplier chaos.</p>
              </div>
              <div className="feature-wavy-line"></div>
            </div>
            <div className="feature-illustration"></div>
          </div>

          {/* Feature 03 */}
          <div className="about-feature">
            <div className="feature-content">
              <h3 className="feature-subtitle">Editable Timeline <span className="live-badge">LIVE</span></h3>
              <div className="feature-text">
                <p>A ready-to-go wedding day schedule you can customise to fit your plans. Adjust the timings, add your own notes, and keep everything in one place — so everyone knows what's happening, when.</p>
                <p className="plan-feature-tagline">
                  <span>No guessing, no chaos. Just a timeline that actually works.</span>
                </p>
              </div>
              <div className="feature-wavy-line"></div>
            </div>
            <div className="feature-illustration"></div>
          </div>

          {/* Feature 04 */}
          <div className="about-feature">
            <div className="feature-content">
              <h3 className="feature-subtitle">Custom Lists</h3>
              <div className="feature-text">
                <p>Need a shot list for your photographer? A checklist for flowers? A packing list for the big day? Create and edit your own lists so nothing gets forgotten (and no one says "we missed the confetti photo").</p>
                <p className="plan-feature-tagline">All in one place, stress-free.</p>
              </div>
              <div className="feature-wavy-line"></div>
            </div>
            <div className="feature-illustration"></div>
          </div>

          {/* Feature 05 */}
          <div className="about-feature">
            <div className="feature-content">
              <h3 className="feature-subtitle">Budget Graphics <span className="live-badge">LIVE</span></h3>
              <div className="feature-text">
                <p>Keep your wedding budget from spiraling out of control. See your spending in clear, colorful charts — track costs, spot overspending, and make sure your dream day doesn't bankrupt you.</p>
              </div>
              <div className="feature-wavy-line"></div>
            </div>
            <div className="feature-illustration"></div>
          </div>

          {/* Feature 06 */}
          <div className="about-feature">
            <div className="feature-content">
              <h3 className="feature-subtitle">PDF Documents</h3>
              <div className="feature-text">
                <p>Turn all your wedding plans — timelines, budgets, checklists — into sleek, shareable PDFs. Keep everything in one place, stay on top of every detail, and finally feel like you actually have it together. Stress-free, pretty, and totally under control.</p>
              </div>
              <div className="feature-wavy-line"></div>
            </div>
            <div className="feature-illustration"></div>
          </div>
        </div>
      </section>

      {/* ===== BACK TO PRICING BUTTON ===== */}
      <section style={{ textAlign: 'center', padding: '10px 2rem 60px' }}>
        <a href="#pricing" className="btn-back-pricing">Back to Pricing</a>
      </section>

      {/* ===== WEDDING CEO SECTION ===== */}
      <section id="wedding-ceo" className="plan-section">
        <h2 className="plan-title">WEDDING CEO</h2>
        <div className="plan-wavy-line"></div>

        <div className="plan-content">
          {/* Feature 01 */}
          <div className="about-feature">
            <div className="feature-content">
              <h3 className="feature-subtitle">Dynamic Wedding Checklist</h3>
              <div className="feature-text">
                <p>Your checklist gets even smarter. Tasks come with reminders you can sync directly to your Google Calendar — so nothing slips through the cracks, and you stay two steps ahead.</p>
              </div>
              <div className="feature-wavy-line"></div>
            </div>
            <div className="feature-illustration">
              <img src="/img/angel.png" alt="Dynamic Wedding Checklist" className="feature-img" />
            </div>
          </div>

          {/* Feature 02 */}
          <div className="about-feature">
            <div className="feature-content">
              <h3 className="feature-subtitle">RSVP's & Guest Manager</h3>
              <div className="feature-text">
                <p>Take it to the next level. Now you can manage responses across multiple events — rehearsal dinner, ceremony, after-party — all from the same dashboard. Plus, create and customize your seating chart effortlessly.</p>
              </div>
              <div className="feature-wavy-line"></div>
            </div>
            <div className="feature-illustration"></div>
          </div>

          {/* Feature 03 */}
          <div className="about-feature">
            <div className="feature-content">
              <h3 className="feature-subtitle">Invitation Designs</h3>
              <div className="feature-text">
                <p>Your invites, your rules. Pick a design, then tweak colors, fonts, and text until it's 100% you. No more boring templates — make them as extra (or chill) as you want.</p>
              </div>
              <div className="feature-wavy-line"></div>
            </div>
            <div className="feature-illustration"></div>
          </div>

          {/* Feature 04 */}
          <div className="about-feature">
            <div className="feature-content">
              <h3 className="feature-subtitle">Budget Graphics</h3>
              <div className="feature-text">
                <p>Keep your wedding budget from spiraling out of control. See your spending in clear, colorful charts — track costs, spot overspending, and make sure your dream day doesn't bankrupt you.</p>
              </div>
              <div className="feature-wavy-line"></div>
            </div>
            <div className="feature-illustration"></div>
          </div>

          {/* Feature 05 */}
          <div className="about-feature">
            <div className="feature-content">
              <h3 className="feature-subtitle">Master Spreadsheet</h3>
              <div className="feature-text">
                <p>All your wedding chaos in one place. Combine the timeline with vendor schedules, assign tasks per provider, track music for every moment, and know exactly who's in charge of what.</p>
                <p className="plan-feature-tagline">Finally, a plan that actually makes sense.</p>
              </div>
              <div className="feature-wavy-line"></div>
            </div>
            <div className="feature-illustration">
              <img src="/img/mujerDentroDeUnaCopa.png" alt="Master spreadsheet" className="feature-img" />
            </div>
          </div>

          {/* Feature 06 */}
          <div className="about-feature">
            <div className="feature-content">
              <h3 className="feature-subtitle">Everything Talks</h3>
              <div className="feature-text">
                <p>Nothing lives in isolation. Vendors sync with your budget, meeting dates link to tasks, and all your info feeds into the Master Spreadsheet. It's like your wedding planning finally grew a brain — and it actually helps you.</p>
              </div>
              <div className="feature-wavy-line"></div>
            </div>
            <div className="feature-illustration"></div>
          </div>
        </div>
      </section>

      {/* ===== BACK TO PRICING BUTTON ===== */}
      <section style={{ textAlign: 'center', padding: '10px 2rem 60px' }}>
        <a href="#pricing" className="btn-back-pricing">Back to Pricing</a>
      </section>
    </>
  )
}

export default Pricing
